import Button from "@mui/material/Button"

export const EditorDisconnectActionButton = () => (
  <Button
    onClick={() => {
      window.location.reload()
    }}
    variant="contained"
  >
    Reload
  </Button>
)
